import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {IOsrmRoute} from '../../core/interfaces/zones.interface';
import {IDriverScheduleTrip} from '../../core/interfaces/schedule-trip.interface';

@Injectable()
export class AutoSchedulerService extends ParentService {
  private OSRM = 'https://osrm.trip2.com/';
  private ROUTEURL = this.OSRM + 'route/v1/driving/';
  private TRIPURL = this.OSRM + 'trip/v1/driving/';
  constructor(private http: Http) {
    super();
  }
  osrmRoutePath(from: any, to: any) {
    return this.http
      .get( this.ROUTEURL +
        from.lng + ',' + from.lat + ';' + to.lng + ',' + to.lat)
      .map(res => res.json());
  }
  osrmFullPath(locations): Observable<IOsrmRoute> {
    let url = this.ROUTEURL;
    locations.forEach((element, index) => {
      url += (index === 0 ? '' : ';') + element.lng + ',' + element.lat;
    });
    return this.http
      .get(url)
      .map(res => res.json());
  }
  osrmBestRoute(locations) {
    let url = this.TRIPURL;
    locations.forEach((element, index) => {
      url += (index === 0 ? '' : ';') + element.lng + ',' + element.lat;
    });
    url += '?roundtrip=false&source=first&destination=last';
    return this.http
      .get(url)
      .map(res => res.json());
  }
  getDriverTrips(driverId, dateOfService) {
    return this.http
      .get(`${constant.BASIC}ScheduleTrip/List/${driverId}/${dateOfService}`, this.getHeader())
      .map(res => res.json());
  }

  startSchedule(time, date, driverId) {
    return this.http.post(constant.BASIC + 'ScheduleTrip',
      {put: time, date: date, driverid: driverId},
      this.getHeader()).map(res => res.json());
  }
  editStartingSchedule(obj) {
    return this.http.put(constant.BASIC + 'ScheduleTrip', obj, this.getHeader()).map(res => res.json());
  }
  addTrip(tripId, driverId, vehicleId, date) {
    return this.http.post(constant.BASIC + 'ScheduleTrip',
      {tripid: tripId, date: date, driverid: driverId, vehicleid: vehicleId},
      this.getHeader()).map(res => res.json());
  }
  addTrips(tripsId, driverId, vehicleId, date) {
    return this.http.post(constant.BASIC + 'ScheduleTrip/AssignTrips',
      {TripsToAssign: tripsId, DateOfService: date, DriverId: driverId, VehicleId: vehicleId},
      this.getHeader()).map(res => res.json());
  }
  removeTrip(id) {
    return this.http.delete(constant.BASIC + 'ScheduleTrip/' + id, this.getHeader())
    .map(res => res.json());
  }
  reOrderTrip(id, toIndex) {
    return this.http.put(constant.BASIC + `ScheduleTrip/UpdateOrder/${id}/${toIndex}`, {}, this.getHeader())
    .map(res => res.json());
  }
  getTrips(date, providerId) {
    return this.http
      .get(
        `${constant.URL_TRIP_SEARCH}/TripsByFilters/${date}?providerId=${providerId}&isSchedule=false&showActive=false&onlyOpen=true`,
        this.headerPost()
      ).map((res) => res.json());
  }


  getRouteToPickUp(tripId: number, driverId: number): Observable<IDriverScheduleTrip[]> {
    return this.http.get(`${constant.URL_SCHEDULE_TRIPS_ROUTE_TO_PICK_UP}/${tripId}/${driverId}`, this.getHeader()).map(res => res.json());
  }

  getTimeNow() {
    return this.http
      .get(constant.URL_DATE_TIME_NOW, this.getHeader())
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/auto-scheduler/auto-scheduler.service.ts